//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Validate.js";
import "../no/TaggedObject.js";
let d=[[[0,"AutoDisplayResults",1,0],[0,"ExcludeNonOwnerParts",1,0],[0,"ExcludeReadonlyParts",1,0],[0,"GenerateCheckFlag",1,0],[0,"GenerateLogFile",1,0],[0,"LogFileDirectory",1,0],[0,"LogFileMode",1,0],[0,"ResultsAutoUpdate",1,0],[0,"SavePartFile",1,0],[0,"SaveResultInPart",1,0],[0,"SaveResultInTeamcenter",1,0],[0,"SkipChecking",1,0],[0,"SkipCheckingDontLoadPart",1,0],[0,"SkipOverriddenResultOption",1,0],[0,"StopOnError",1,0],[0,"StopOnWarning",1,0],[0,"TreatWarningAsFail",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Validate.ValidatorOptions = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Validate.ValidatorOptions";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Validate.ValidatorOptions.LogModeTypes = Object.freeze({
    "LogPerSession" : "LogPerSession", "LogPerPart" : "LogPerPart"});

SPLM.Validate.ValidatorOptions.SaveModeTypes = Object.freeze({
    "DoNotSave" : "DoNotSave", "SaveIfPassed" : "SaveIfPassed", "AlwaysSave" : "AlwaysSave"});

SPLM.Validate.ValidatorOptions.ResultsDisplayModeTypes = Object.freeze({
    "AlwaysDisplay" : "AlwaysDisplay", "DisplayIfNotPass" : "DisplayIfNotPass", "DoNotDisplay" : "DoNotDisplay"});

export default SPLM;